export const TurnList = (destinationLang) => {
  return [
    {
      FormKey: "turn-list-alert-make-sure-cancel",
      Key: "آیا از لغو نوبت اطمینان دارید",
      DistinitationLanguage: destinationLang,
    },
  ];
};
